import * as React from 'react';
import { Aeroexpress as AeroexpressRoot } from '../../../../../../CheckoutAdditionalService/components';
import { GdsAggregationServiceGroup } from '../../../../../types';
import { AeroexpressFragment, AeroexpressSelectedTrip, AeroexpressTrip } from '@websky/graphql';

interface Props {
	segmentId?: string;
	service?: GdsAggregationServiceGroup;
}

const AggregatedAeroexpress: React.FC<Props> = ({ service, segmentId }) => {
	const aeroexpress: AeroexpressFragment['aeroexpress'] = {
		trips: service.services as AeroexpressTrip[],
		selectedTrips: service.selectedServices.map(selected => selected.service) as AeroexpressSelectedTrip[]
	};

	return (
		<AeroexpressRoot
			aggregationMode={true}
			segmentId={segmentId}
			aeroexpress={aeroexpress}
			isSelected={!!aeroexpress.selectedTrips.length}
			icons={['Airport/Subway', 'Info/Time']}
		/>
	);
};

export default AggregatedAeroexpress;
